module.exports = __webpack_public_path__ + "img/icon5.2ac23dca.png";